import React from "react";
import DataTable from "react-data-table-component";
import "./DataTable.css";


const TableComponent = ({ customStyles, columns, data, totalRows, handlePageChange, handlePerRowsChange, isPagination, resetPagination, isPerPageHide, noHeader }) => {

    const customStylesData = customStyles || {
        rows: {
            style: {
                minHeight: '40px', whiteSpace: 'normal', textAlign: "center"
            },
        },
        headCells: {
            style: {
                fontSize: '13px', fontWeight: '600', paddingLeft: '0px', paddingRight: '0px', color: 'var(--white-text)', whiteSpace: 'normal', textAlign: "center"
            },
        },
        cells: {
            style: {
                fontSize: '12px', paddingLeft: '0px', paddingRight: '0px', paddingTop: '3px', paddingBottom: '3px', whiteSpace: 'normal', textAlign: "center"
            },
        },
        footCells: { style: { backgroundColor: 'var(--primary-background)', textAlign: "center", color: 'var(--white-text)' } }
    };

    customStylesData.headCells.style.backgroundColor = 'var(--primary-background)';
    customStylesData.headCells.style.color = 'var(--white-text)';

    const paginationComponentOptions = {
        noRowsPerPage: isPerPageHide
    };

    return (<>
        <div className="tableMain">
            <DataTable
                data={data}
                columns={columns}
                pagination={isPagination ?? true}
                paginationServer
                noTableHead={noHeader || false}
                paginationTotalRows={totalRows}
                paginationResetDefaultPage={resetPagination}
                paginationDefaultPage={1}
                onChangePage={(page, totalRows) => handlePageChange(page)}
                onChangeRowsPerPage={(newPerPage, page) => handlePerRowsChange(newPerPage, page)}
                customStyles={customStylesData}
                paginationComponentOptions={paginationComponentOptions}
            />
        </div>
    </>);
};

export default TableComponent;